import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-editaccessmanagementone',
  templateUrl: './editaccessmanagementone.component.html',
  styleUrls: ['./editaccessmanagementone.component.css']
})
export class EditaccessmanagementoneComponent implements OnInit {
  returnUrl= "/dashboard/accessmanagement";
  constructor(private router:Router) { }

  ngOnInit(): void {
    
  }
  accessmanagement(){
    this.router.navigate([this.returnUrl]);
  }
}
